'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.load = load;
exports.isLoaded = isLoaded;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * We obtain the user credentials
 * This tells us if the user is an admin or not
 * And then we can use this flag to display certain pages
 */

/* eslint-disable */
var LOAD_ALL = 'LOAD_ALL';
var LOAD_USER_CREDENTIAL_SUCCESS = 'LOAD_USER_CREDENTIAL_SUCCESS';
var LOAD_ALL_FAIL = 'LOAD_ALL_FAIL';

var initialState = {
  loaded: false,
  updating: false,
  updateError: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {

    case LOAD_ALL:
      return (0, _extends3.default)({}, state, {
        loaded: false
      });
    case LOAD_USER_CREDENTIAL_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loaded: true,
        'isAdmin': action.result.isAdmin
      });
    case LOAD_ALL_FAIL:
      return (0, _extends3.default)({}, state, {
        loaded: false
      });
    default:
      return state;
  }
}

/*
  return inital state for all usercredentials
 */
function load(userId) {
  // console.log(userId.auth.user.userId);
  // userId = userId.auth.user.userId; // getState();
  var url = '/userCredentials/load';
  return {
    types: [LOAD_ALL, LOAD_USER_CREDENTIAL_SUCCESS, LOAD_ALL_FAIL],
    promise: function promise(client) {
      return client.get(url, {
        params: {
          userId: userId
        }
      });
    }
  };
}

function isLoaded(globalState) {
  return globalState.moduleData && globalState.moduleData.loaded;
}

/* eslint-enable */


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/userCredential.js
// module id = 520
// module chunks = 0